export default __webpack_public_path__ + "static/media/CloseTab-red.2a972a7e.svg";